import * as classnames from 'classnames/bind'
import { startsWith } from 'lodash'
import * as React from 'react'
import { FC, ReactElement } from 'react'
import UrlUtil from 'utilities/url_util'
import styles from './side_nav_item.module.scss'

type Props = {
  belongs?: string
  className?: string
  enable: boolean
  icon?: ReactElement
  isCollapseDisabled?: boolean
  only?: boolean
  path: string
  title: string
}

const cx = classnames.bind(styles)
const SideNavItem: FC<Props> = ({
  belongs,
  className,
  enable,
  icon,
  isCollapseDisabled = true,
  only = false,
  path,
  title
}) => {
  if (!enable) {
    return null
  }

  const targetPath = belongs || path
  const currentPath = UrlUtil.getUrlPathname()

  return (
    <a
      className={cx(className, styles.link, {
        childLink: !isCollapseDisabled,
        active: only ? currentPath === targetPath : startsWith(currentPath, targetPath)
      })}
      href={path}
    >
      {icon || null}
      {title}
    </a>
  )
}

export default SideNavItem
